export default {
  TEXTS: {
    PROJECT_NAME: '智能垃圾分类现场检查管理平台',
    PROJECT_DESCRIPTION: '欢迎来到'
  }
}
